export default "__VITE_ASSET__DzPyIYVA__"